type TicketCountTextProps = {
  /** Ticket count (Figma `ticket_count_text`). */
  count?: string | number;
};

const DEFAULT_COUNT = '2';

/** Figma `ticket_count_text` (104:25131) — Shnobel 51.056, shadow #4D3C82. */
export function TicketCountText({
  count = DEFAULT_COUNT,
}: TicketCountTextProps) {
  const value = String(count);

  return (
    <svg
      className="tickets-screen-button__count"
      width={100}
      height={58}
      viewBox="0 0 100 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="tickets-screen-button__count-text"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        <tspan x={50} y={45}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}
